var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompatibleAppList"},_vm._l((_vm.compatibleApps),function(app,appIndex){return _c('router-link',{key:app.appstoreID + appIndex,staticClass:"CompatibleAppListItem",attrs:{"to":{
      name: 'app-detail',
      params: {
        appType: app.type || 'app',
        appName: app.friendlyID || 'null',
        tab: 'overview',
      },
    }}},[_c('AppIcon',{staticClass:"_icon",attrs:{"size":24,"src":app.logo}}),_vm._v(" "+_vm._s(app.title)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }